export const DECIMAL_PRECISION = 6;

export const DECIMAL_EPSILON = 1e-6;

export const stripFloatNoise = (value: number): number => Number(value.toFixed(DECIMAL_PRECISION));
